import React from 'react';
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import AttachMoneyRoundedIcon from "@material-ui/icons/AttachMoneyRounded";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import HeadsetMicRoundedIcon from '@material-ui/icons/HeadsetMicRounded';
//import TrendingUpRoundedIcon from '@material-ui/icons/TrendingUpRounded';
//import EventRoundedIcon from '@material-ui/icons/EventRounded';
import AddShoppingCartOutlinedIcon from '@material-ui/icons/AddShoppingCartOutlined';
import StarBorderOutlinedIcon from '@material-ui/icons/StarBorderOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import BusinessIcon from '@material-ui/icons/Business';
import { Link } from "react-router-dom";
import {history} from "store"
import IntlMessages from 'util/IntlMessages';

function TileData(props) {
  const UserRole = props.authUser.user_role
  const OfficeId = props.authUser.user_OfficeId
  const CanSeeAllkontoKontorsDB = props.authUser.user_CanSeeAllkontoKontorsDB
  let KanseeKontor = parseInt(UserRole) > 1?
  parseInt(OfficeId) > 0?
  parseInt(CanSeeAllkontoKontorsDB)
  :1  
  :1
  return (
  <div>
    <ListItem onClick={() => history.push("/app/Dashboard")}>
      <ListItemIcon>
        <PermIdentityIcon color="primary" />
      </ListItemIcon>
      <ListItemText>
        <Link style={{ fontSize: 18 }} to="dashboard"><IntlMessages id="DashBoard.Individual"/></Link>
      </ListItemText>
    </ListItem>
    <ListItem onClick={() => history.push("/app/Dashboardprospekt")}>
      <ListItemIcon>
        <StarBorderOutlinedIcon color="primary" />
      </ListItemIcon>
      <ListItemText>
        <Link style={{ fontSize: 18 }} to="Dashboardprospekt"><IntlMessages id="DashBoard.Overview"/></Link>
      </ListItemText>
    </ListItem>
    <ListItem onClick={() => history.push("/app/DashboardSalj")}>
      <ListItemIcon>
        <AttachMoneyRoundedIcon color="primary" />
      </ListItemIcon>
      <ListItemText>
        <Link style={{ fontSize: 18 }} to="DashboardSalj"><IntlMessages id="DashBoard.Sale.TV"/></Link>
      </ListItemText>
    </ListItem>
    <ListItem onClick={() => history.push("/app/DashboardBokning")}>
      <ListItemIcon>
        <EventAvailableIcon color="primary" />
      </ListItemIcon>
      <ListItemText>
        <Link style={{ fontSize: 18 }} to="DashboardBokning"><IntlMessages id="DashBoard.Booking.TV"/></Link>
      </ListItemText>
    </ListItem>
    {
      parseInt(KanseeKontor) === 1?
      
    <ListItem onClick={() => history.push("/app/DashboardKontor")}>
      <ListItemIcon>
        <BusinessIcon color="primary" />
      </ListItemIcon>
      <ListItemText>
        <Link style={{ fontSize: 18 }} to="DashboardKontor"><IntlMessages id="Office"/></Link>
      </ListItemText>
    </ListItem>
    :""
  }
    {
      parseInt(props.isIamChild) > 0?
      
    <ListItem onClick={() => history.push("/app/Dashboardkonton")}>
      <ListItemIcon>
        <BusinessIcon color="primary" />
      </ListItemIcon>
      <ListItemText>
        <Link style={{ fontSize: 18 }} to="DashboardBarn"><IntlMessages id="DashBoard.Accounts"/></Link>
      </ListItemText>
    </ListItem>
    :""
  }
    <ListItem onClick={() => history.push("/app/DashboardOrder")}>
      <ListItemIcon>
        <AddShoppingCartOutlinedIcon color="primary" />
      </ListItemIcon>
      <ListItemText>
        <Link style={{ fontSize: 18 }} to="DashboardOrder"><IntlMessages id="Order"/></Link>
      </ListItemText>
    </ListItem>
    {/*
    <ListItem disabled onClick={() => history.push("/app/DashboardAktiviteter")}>
      <ListItemIcon>
        <EventRoundedIcon color="primary" />
      </ListItemIcon>
      <ListItemText>
        <Link style={{ fontSize: 18 }} to="DashboardAktiviteter"><IntlMessages id="Activities"/></Link>
      </ListItemText>
    </ListItem>
    */}
    <ListItem onClick={() => history.push("/app/DashboardDialer")}>
      <ListItemIcon>
        <HeadsetMicRoundedIcon color="primary" />
      </ListItemIcon>
      <ListItemText>
        <Link style={{ fontSize: 18 }} to="DashboardDialer"><IntlMessages id="DashBoard.Dialer"/></Link>
      </ListItemText>
    </ListItem>
    {/*
    <ListItem disabled onClick={() => history.push("/app/DashboardPrognos")}>
      <ListItemIcon>
        <TrendingUpRoundedIcon color="primary" />
      </ListItemIcon>
      <ListItemText>
        <Link style={{ fontSize: 18, }} to="DashboardPrognos"><IntlMessages id="Date.Forecast"/></Link>
      </ListItemText>
    </ListItem>
    
    */}
    <ListItem onClick={() => history.push("/app/DashboardProjekt")}>
      <ListItemIcon>
        <AssignmentOutlinedIcon color="primary" />
      </ListItemIcon>
      <ListItemText>
        <Link style={{ fontSize: 18, }} to="DashboardProjekt"><IntlMessages id="Project"/></Link>
      </ListItemText>
    </ListItem>
  </div>
);
}

export default TileData;
